(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hsbd-pad-hub"] && !Shopify.designMode) return;
  try {
    
function hsbdInitPadHubs(root=document){
 root.querySelectorAll('.pad-color-section').forEach(section=>{
  if(section.dataset.padInitialized)return;
  section.dataset.padInitialized='true';
  const track=section.querySelector('.pad-hub-track,.pad-hub-grid');
  if(!track)return;
  const cards=Array.from(track.querySelectorAll('.pad-hub-card'));
  const scrollButtons=section.querySelectorAll('[data-pad-scroll]');
  const tabs=Array.from(section.querySelectorAll('[data-pad-type]'));
  const tablist=section.querySelector('.pad-type-tabs');
  const panel=section.querySelector('[role="tabpanel"]');
  const empty=section.querySelector('.pad-type-empty');
  const baseFilter=section.querySelector('.pad-base-filter');
  const baseSelect=section.querySelector('[data-pad-base-select]');
  let currentType='all', currentBase='all';
  if(baseFilter)baseFilter.hidden=false;
  const links=Array.from(section.querySelectorAll('.pad-hub-actions a'));
  links.forEach(link=>{link.dataset.baseHref=link.getAttribute('href')});
  if(track.classList.contains('pad-hub-track')){
   const hueOrder=section.closest('.hsbd-pad-hub').dataset.hueOrder==='true';
   cards.sort((a,b)=>hueOrder?Number(a.dataset.colorRank)-Number(b.dataset.colorRank):(Number(a.dataset.featureRank)||999)-(Number(b.dataset.featureRank)||999)||Number(b.dataset.created)-Number(a.dataset.created));
   cards.forEach(card=>track.append(card));
  }
  const update=()=>scrollButtons.forEach(button=>{button.disabled=Number(button.dataset.padScroll)<0?track.scrollLeft<=2:track.scrollLeft+track.clientWidth>=track.scrollWidth-2});
  function select(type,focus=false,base=currentBase){
   currentType=type;currentBase=base;
   let visible=0;
   cards.forEach(card=>{card.hidden=(type!=='all'&&card.dataset.padKind!==type)||(base!=='all'&&card.dataset.padBase!==base);if(!card.hidden)visible++});
   tabs.forEach(tab=>{const active=tab.dataset.padType===type;tab.setAttribute('aria-selected',String(active));tab.tabIndex=active?0:-1;if(active){panel.setAttribute('aria-labelledby',tab.id);if(focus)tab.focus()}});
   empty.hidden=visible>0;
   if(baseSelect)baseSelect.value=base;
   links.forEach(link=>{link.href=link.dataset.baseHref+((type==='all'&&base==='all')?'':'#pad-type-'+type+';pad-base-'+base)});
   track.scrollLeft=0;update();
  }
  if(baseSelect)baseSelect.addEventListener('change',()=>select(currentType,false,baseSelect.value));
  tabs.forEach((tab,index)=>{
   tab.addEventListener('click',()=>select(tab.dataset.padType));
   tab.addEventListener('keydown',event=>{
    let next=index;
    if(event.key==='ArrowRight')next=(index+1)%tabs.length;
    else if(event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;
    else if(event.key==='Home')next=0;
    else if(event.key==='End')next=tabs.length-1;
    else return;
    event.preventDefault();select(tabs[next].dataset.padType,true);
   });
  });
  scrollButtons.forEach(button=>button.addEventListener('click',()=>track.scrollBy({left:Number(button.dataset.padScroll)*track.clientWidth*.85,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})));
  track.addEventListener('scroll',update,{passive:true});
  new ResizeObserver(update).observe(track);
  tablist.hidden=false;
  const requested=(location.hash.match(/pad-type-(all|show|ranch)/)||[])[1]||section.closest('.hsbd-pad-hub').dataset.defaultPadType;
  const requestedBase=(location.hash.match(/pad-base-(all|black|brown|colored)/)||[])[1]||'all';
  select(['show','ranch'].includes(requested)?requested:'all',false,baseFilter&&['black','brown','colored'].includes(requestedBase)?requestedBase:'all');
 });
 root.querySelectorAll('.pad-color-browser').forEach(browser=>{
  if(browser.dataset.initialized)return;
  const links=Array.from(browser.querySelectorAll('.pad-color-links a'));
  const panels=Array.from(browser.querySelectorAll('.pad-color-section'));
  if(!links.length||!panels.length)return;
  function showColor(link){
   const target=link.getAttribute('href').slice(1);
   panels.forEach(panel=>panel.hidden=panel.id!==target);
   links.forEach(item=>item.setAttribute('aria-current',String(item===link)));
  }
  links.forEach(link=>link.addEventListener('click',event=>{event.preventDefault();showColor(link)}));
  const current=links.find(link=>link.getAttribute('href')===location.hash)||links[0];
  showColor(current);browser.classList.add('pad-browser-ready');browser.dataset.initialized='true';
 });
}
hsbdInitPadHubs();document.addEventListener('shopify:section:load',event=>hsbdInitPadHubs(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hsbd-shop-all-collection-shelves"] && !Shopify.designMode) return;
  try {
    
(() => {
  const update = (carousel) => {
    const track = carousel.querySelector('[data-hsbd-shop-all-track]');
    const previous = carousel.querySelector('[data-hsbd-shop-all-scroll="-1"]');
    const next = carousel.querySelector('[data-hsbd-shop-all-scroll="1"]');
    if (!track || !previous || !next) return;
    previous.disabled = track.scrollLeft <= 1;
    next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
  };
  const initialize = (scope) => {
    scope.querySelectorAll('[data-hsbd-shop-all-carousel]').forEach((carousel) => {
      if (carousel.dataset.controlsReady) return;
      carousel.dataset.controlsReady = 'true';
      const track = carousel.querySelector('[data-hsbd-shop-all-track]');
      if (!track) return;
      track.addEventListener('scroll', () => update(carousel), { passive:true });
      update(carousel);
      requestAnimationFrame(() => update(carousel));
    });
  };
  const bind = () => {
    if (window.hsbdShopAllShelfControlsReady) return;
    window.hsbdShopAllShelfControlsReady = true;
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-hsbd-shop-all-scroll]');
      if (!button) return;
      const carousel = button.closest('[data-hsbd-shop-all-carousel]');
      const track = carousel && carousel.querySelector('[data-hsbd-shop-all-track]');
      if (!track) return;
      const direction = Number(button.dataset.hsbdShopAllScroll);
      const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollBy({ left:direction*Math.max(track.clientWidth*.82,200), behavior:reduced?'auto':'smooth' });
    });
    window.addEventListener('resize', () => document.querySelectorAll('[data-hsbd-shop-all-carousel]').forEach(update));
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  };
  const start = () => { bind(); initialize(document); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once:true });
  else start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hsbd-simply-hub"] && !Shopify.designMode) return;
  try {
    
function hsbdOrderSimplyHubResults(root = document) {
  root.querySelectorAll('.hsbd-hub-results-grid[data-hub-member-order]').forEach(function(grid) {
    let order;
    try { order = JSON.parse(grid.dataset.hubMemberOrder || '[]'); } catch (error) { return; }
    if (!Array.isArray(order) || !order.length) return;
    const rank = new Map(order.map(function(id, index) { return [String(id), index]; }));
    const cards = Array.from(grid.querySelectorAll(':scope > .product-index[data-product-id]'));
    cards.sort(function(a, b) {
      const rankA = rank.has(String(a.dataset.productId)) ? rank.get(String(a.dataset.productId)) : Number.MAX_SAFE_INTEGER;
      const rankB = rank.has(String(b.dataset.productId)) ? rank.get(String(b.dataset.productId)) : Number.MAX_SAFE_INTEGER;
      return rankA - rankB;
    });
    cards.forEach(function(card) { grid.appendChild(card); });
  });
}
function hsbdInitSimplyHub(root = document) {
  hsbdOrderSimplyHubResults(root);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function() { hsbdInitSimplyHub(); });
else hsbdInitSimplyHub();
document.addEventListener('shopify:section:load', function(event) { hsbdInitSimplyHub(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hsbd-southwestern-shop-all"]) return;
  try {
    
(function() {
  const section = document.querySelector('.hsbd-southwestern-shop-all');
  const grid = section && section.querySelector('[data-southwestern-hue-grid]');
  if (!section || !grid) return;
  const terms = [
    ['matte black',0,0],['black',0,0],['dark charcoal',0,1],['charcoal',0,2],['gunmetal',0,3],['silver',0,4],['gray',0,5],['grey',0,5],['espresso',0,7],['deep chocolate',0,8],['dark chocolate',0,9],['milk chocolate',0,10],['chocolate',0,11],['buckskin',0,12],['taupe',0,13],['whiskey',0,14],['tan',0,15],['sand',0,16],['caramel',0,17],['off white',0,19],['ivory',0,20],['white',0,21],['pale cream',0,22],['cream',0,23],
    ['dark burgundy',1,0],['iridescent burgundy',1,1],['fig burgundy',1,2],['merlot',1,3],['garnet',1,4],['cranberry',1,5],['dark berry',1,6],['bright red',1,8],['classic red',1,9],['red',1,10],
    ['electric magenta',2,0],['hot raspberry',2,0],['fuchsia',2,2],['dragonfruit',2,4],['bubblegum',2,5],['pink',2,6],['dusty rose',2,7],['rose gold',2,8],['pale blush',2,9],
    ['copper',3,1],['rust',3,2],['marmalade',3,3],['tangerine',3,4],['orange dream',3,5],['orange',3,6],['hot coral',3,7],['coral',3,8],['melon',3,9],['georgia peach',3,10],['peach',3,11],
    ['bronze',4,0],['gold',4,1],
    ['forest green',5,0],['hunter green',5,1],['dark sage',5,2],['emerald',5,3],['olive grove',5,4],['bright olive',5,5],['olive',5,6],['avocado',5,7],['kelly green',5,8],['jade',5,9],['sage green',5,10],['sage',5,10],['lime',5,12],['seafoam',5,13],
    ['dark teal',6,0],['deep navy',6,1],['dark navy',6,2],['royal navy',6,3],['navy',6,4],['indigo',6,5],['dark denim',6,6],['denim',6,7],['steel blue',6,8],['royal blue',6,9],['royal',6,9],['icey blue',6,10],['periwinkle',6,11],['tiffany blue',6,12],['rich turquoise',6,13],['turquoise',6,14],['teal',6,15],['aqua',6,16],['blue',6,17],
    ['eggplant',7,0],['aubergine',7,1],['grape jelly',7,2],['dusty purple',7,3],['royal purple',7,4],['electric purple',7,5],['iridescent purple',7,6],['thistle',7,7],['orchid',7,8],['dark lavender',7,9],['icey lavender',7,10],['lavender',7,11],['lilac',7,12],['soft purple',7,13],['purple',7,14]
  ];

  function rank(card) {
    const title = String(card.dataset.productTitle || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    let best = null;
    terms.forEach(function(term, order) {
      const index = title.indexOf(term[0]);
      if (index < 0) return;
      const candidate = [index, -term[0].length, term[1], term[2], order];
      if (!best || candidate[0] < best[0] || (candidate[0] === best[0] && candidate[1] < best[1])) best = candidate;
    });
    return best ? [best[2], best[3], title] : [99, 99, title];
  }

  function sortSouthwesternGrid() {
      const cards = Array.from(grid.querySelectorAll(':scope > .product-index[data-product-id]'));
      const sorted = cards.slice().sort(function(a, b) {
        const aRank = rank(a);
        const bRank = rank(b);
        return aRank[0] - bRank[0] || aRank[1] - bRank[1] || aRank[2].localeCompare(bRank[2]);
    });
      if (cards.some(function(card, index) { return card !== sorted[index]; })) sorted.forEach(function(card) { grid.appendChild(card); });
  }

  const collectionUrl = section.dataset.southwesternCollectionUrl;
  const stockToggle = section.querySelector('[data-hsbd-stock-only-toggle]');
  const stockCount = section.querySelector('[data-hsbd-stock-count]');

  if (stockToggle) {
    const stockStorageKey = 'hsbdCollectionPhysicalStockOnly:' + window.location.pathname;
    const readStockState = function() {
      try { return window.sessionStorage.getItem(stockStorageKey) === '1'; }
      catch (error) { return false; }
    };
    const writeStockState = function(enabled) {
      try { window.sessionStorage.setItem(stockStorageKey, enabled ? '1' : '0'); }
      catch (error) {}
    };
    const applyStockState = function(enabled) {
      stockToggle.checked = enabled;
      grid.classList.toggle('hsbd-stock-only-enabled', enabled);
      const physicalCount = grid.querySelectorAll(':scope > .product-index[data-product-id][data-hsbd-physical-stock="true"]').length;
      if (stockCount) {
        stockCount.textContent = enabled
          ? (physicalCount
            ? physicalCount + ' IN-STOCK ITEM' + (physicalCount === 1 ? '' : 'S') + ' ON THIS PAGE'
            : 'NO IN-STOCK ITEMS ON THIS PAGE. TRY ANOTHER PAGE OR TURN OFF THIS FILTER.')
          : '';
      }
    };
    stockToggle.addEventListener('change', function() {
      writeStockState(stockToggle.checked);
      applyStockState(stockToggle.checked);
    });
    applyStockState(readStockState());
  }

  function filteredCollectionUrl(candidate) {
    const target = new URL(candidate || collectionUrl, window.location.origin);
    const base = new URL(collectionUrl, window.location.origin);
    target.pathname = base.pathname;
    target.hash = '';
    return target.toString();
  }

  section.addEventListener('click', function(event) {
    const option = event.target.closest('.js-hz-filter-list li[data-add], .js-current-filter');
    if (!option || !section.contains(option)) return;
    let destination = '';
    if (option.matches('.js-current-filter')) {
      destination = option.href;
    } else {
      destination = option.classList.contains('current') ? option.dataset.remove : option.dataset.add;
    }
    if (!destination) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(filteredCollectionUrl(destination));
  }, true);

  section.addEventListener('change', function(event) {
    if (!event.target.matches('.js-filter-range-input')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const form = section.querySelector('#CollectionFiltersForm');
    const params = new URLSearchParams(new FormData(form));
    const destination = new URL(collectionUrl, window.location.origin);
    destination.search = params.toString();
    window.location.assign(destination.toString());
  }, true);

  section.addEventListener('submit', function(event) {
    if (!event.target.matches('#CollectionFiltersForm')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const params = new URLSearchParams(new FormData(event.target));
    const destination = new URL(collectionUrl, window.location.origin);
    destination.search = params.toString();
    window.location.assign(destination.toString());
  }, true);

  document.addEventListener('click', function(event) {
    const link = event.target.closest('[data-southwestern-shop-all-link]');
    if (!link || !section) return;
    event.preventDefault();
    section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (window.history && window.history.replaceState) window.history.replaceState(null, '', '#southwestern-shop-all');
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sortSouthwesternGrid);
  else sortSouthwesternGrid();
  new MutationObserver(sortSouthwesternGrid).observe(section.querySelector('#CollectionProductGrid'), { childList: true });
  document.addEventListener('shopify:section:load', sortSouthwesternGrid);
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(() => {
  const storageKey = () => 'hsbdCollectionPhysicalStockOnly:' + window.location.pathname;
  const readState = () => {
    try { return window.sessionStorage.getItem(storageKey()) === '1'; }
    catch (error) { return false; }
  };
  const writeState = (enabled) => {
    try { window.sessionStorage.setItem(storageKey(), enabled ? '1' : '0'); }
    catch (error) {}
  };
  const getQueryKey = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete('page');
    url.searchParams.delete('section_id');
    url.searchParams.delete('sections');
    return url.pathname + '?' + url.searchParams.toString();
  };
  const setCountText = (root, value) => {
    const count = root.querySelector('[data-hsbd-stock-count]');
    if (count) count.textContent = value;
  };
  const getProductCards = (grid) => Array.from(grid.querySelectorAll(':scope > .product-index[data-product-id]'));
  const sectionPageUrl = (page, sectionId) => {
    const url = new URL(window.location.href);
    url.searchParams.set('page', String(page));
    url.searchParams.set('section_id', sectionId);
    url.searchParams.delete('sections');
    return url.toString();
  };
  const fetchRenderedPage = async (page, sectionId, signal) => {
    const response = await fetch(sectionPageUrl(page, sectionId), {
      credentials: 'same-origin',
      signal,
      headers: { Accept: 'text/html' }
    });
    if (!response.ok) throw new Error('A collection page could not be loaded.');
    const markup = await response.text();
    const parsed = new DOMParser().parseFromString(markup, 'text/html');
    const grid = parsed.querySelector('#main-collection-product-grid');
    if (!grid) throw new Error('Shopify did not return the collection product grid.');
    return {
      cards: getProductCards(grid),
      pageCount: Number.parseInt(grid.dataset.hsbdStockPageCount || '', 10)
    };
  };
  const applyLoadedFilter = (root, state) => {
    const grid = root.querySelector('#main-collection-product-grid');
    if (!grid) return;
    const visibleCount = getProductCards(grid).reduce((total, card) => {
      const stocked = card.dataset.hsbdPhysicalStock === 'true';
      card.classList.toggle('hsbd-stock-only-hidden', !stocked);
      if (!stocked) card.setAttribute('aria-hidden', 'true');
      else card.removeAttribute('aria-hidden');
      return total + (stocked ? 1 : 0);
    }, 0);
    grid.classList.add('hsbd-stock-only-enabled');
    root.classList.add('hsbd-stock-only-expanded');
    root.classList.remove('hsbd-stock-only-loading');
    root.removeAttribute('aria-busy');
    setCountText(root, visibleCount
      ? visibleCount + ' IN-STOCK PRODUCT' + (visibleCount === 1 ? '' : 'S') + ' IN THIS COLLECTION'
      : 'NO PHYSICALLY IN-STOCK PRODUCTS IN THIS COLLECTION');
  };
  const loadAllCollectionPages = async (root, state) => {
    const initialGrid = root.querySelector('#main-collection-product-grid');
    if (!initialGrid) return;
    const sectionId = initialGrid.dataset.id;
    if (!sectionId) {
      state.errorMessage = 'ALL COLLECTION PAGES COULD NOT BE CHECKED. FILTER TURNED OFF.';
      writeState(false);
      const toggle = root.querySelector('[data-hsbd-stock-only-toggle]');
      if (toggle) toggle.checked = false;
      setCountText(root, state.errorMessage);
      return;
    }
    const queryKey = getQueryKey();
    const controller = new AbortController();
    const generation = ++state.generation;
    state.controller = controller;
    state.grid = initialGrid;
    state.queryKey = queryKey;
    state.loading = true;
    state.errorMessage = '';
    root.classList.add('hsbd-stock-only-loading');
    root.setAttribute('aria-busy', 'true');
    setCountText(root, 'CHECKING THE FULL COLLECTION FOR PHYSICAL STOCK…');

    try {
      const firstPage = await fetchRenderedPage(1, sectionId, controller.signal);
      const hint = Number.parseInt(initialGrid.dataset.hsbdStockPageCount || '', 10) || 1;
      const pageCount = Math.max(1, firstPage.pageCount || hint);
      const pages = [firstPage.cards];
      const batchSize = 4;
      for (let firstPageNumber = 2; firstPageNumber <= pageCount; firstPageNumber += batchSize) {
        const pageNumbers = Array.from(
          { length: Math.min(batchSize, pageCount - firstPageNumber + 1) },
          (_, index) => firstPageNumber + index
        );
        const batch = await Promise.all(pageNumbers.map((pageNumber) =>
          fetchRenderedPage(pageNumber, sectionId, controller.signal)
        ));
        batch.forEach((page) => pages.push(page.cards));
        if (generation !== state.generation || getQueryKey() !== queryKey) return;
        const checkedThrough = Math.min(firstPageNumber + batchSize - 1, pageCount);
        setCountText(root, 'CHECKED ' + checkedThrough + ' OF ' + pageCount + ' COLLECTION PAGES…');
      }

      if (generation !== state.generation || getQueryKey() !== queryKey || !readState()) return;
      const uniqueCards = [];
      const seenProductIds = new Set();
      pages.forEach((pageCards) => {
        pageCards.forEach((card) => {
          const productId = card.dataset.productId;
          if (!productId || seenProductIds.has(productId)) return;
          seenProductIds.add(productId);
          uniqueCards.push(document.importNode(card, true));
        });
      });

      const currentGrid = root.querySelector('#main-collection-product-grid');
      if (!currentGrid) throw new Error('The collection grid is no longer available.');
      currentGrid.replaceChildren(...uniqueCards);
      state.grid = currentGrid;
      state.loadedKey = queryKey;
      state.loading = false;
      state.controller = null;
      applyLoadedFilter(root, state);
    } catch (error) {
      if (controller.signal.aborted || generation !== state.generation) return;
      state.loading = false;
      state.controller = null;
      state.loadedKey = '';
      state.errorMessage = 'ALL COLLECTION PAGES COULD NOT BE LOADED. SHOW IN STOCK ONLY HAS BEEN TURNED OFF.';
      writeState(false);
      const toggle = root.querySelector('[data-hsbd-stock-only-toggle]');
      if (toggle) toggle.checked = false;
      root.classList.remove('hsbd-stock-only-expanded', 'hsbd-stock-only-loading');
      root.removeAttribute('aria-busy');
      const grid = root.querySelector('#main-collection-product-grid');
      if (grid) grid.classList.remove('hsbd-stock-only-enabled');
      setCountText(root, state.errorMessage);
    }
  };
  const schedule = (root, state) => {
    if (state.frame) return;
    state.frame = window.requestAnimationFrame(() => {
      state.frame = 0;
      const wrapper = root.querySelector('#CollectionProductGrid');
      if (wrapper !== state.wrapper) {
        if (state.wrapperObserver) state.wrapperObserver.disconnect();
        state.wrapper = wrapper;
        if (wrapper) {
          state.wrapperObserver = new MutationObserver(() => schedule(root, state));
          state.wrapperObserver.observe(wrapper, { childList: true, subtree: true });
        }
      }
      const row = root.querySelector('.hsbd-physical-stock-toggle-row');
      const toolbar = root.querySelector('.collection__filter-toggleWrapper .filtering__pagination');
      if (row && toolbar && row.parentElement !== toolbar) {
        toolbar.appendChild(row);
        row.classList.add('hsbd-physical-stock-toggle-row--inline');
      }
      const grid = root.querySelector('#main-collection-product-grid');
      const toggle = root.querySelector('[data-hsbd-stock-only-toggle]');
      const enabled = readState();
      if (toggle && toggle.checked !== enabled) toggle.checked = enabled;
      if (!grid) return;

      const queryKey = getQueryKey();
      if (grid !== state.grid) {
        if (state.controller) state.controller.abort();
        state.generation += 1;
        state.loading = false;
        state.loadedKey = '';
        state.grid = grid;
        state.queryKey = queryKey;
        root.classList.remove('hsbd-stock-only-expanded', 'hsbd-stock-only-loading');
        root.removeAttribute('aria-busy');
      } else if (state.queryKey && state.queryKey !== queryKey) {
        if (state.controller) state.controller.abort();
        state.generation += 1;
        state.loading = false;
        state.loadedKey = '';
        state.queryKey = queryKey;
        root.classList.remove('hsbd-stock-only-expanded', 'hsbd-stock-only-loading');
        root.removeAttribute('aria-busy');
      }

      if (!enabled) {
        if (state.controller) state.controller.abort();
        state.loading = false;
        state.loadedKey = '';
        root.classList.remove('hsbd-stock-only-expanded', 'hsbd-stock-only-loading');
        root.removeAttribute('aria-busy');
        grid.classList.remove('hsbd-stock-only-enabled');
        grid.querySelectorAll('.hsbd-stock-only-hidden').forEach((card) => card.classList.remove('hsbd-stock-only-hidden'));
        grid.querySelectorAll('[aria-hidden="true"]').forEach((card) => card.removeAttribute('aria-hidden'));
        setCountText(root, state.errorMessage || '');
        return;
      }

      if (state.loadedKey === queryKey) {
        applyLoadedFilter(root, state);
        return;
      }
      if (!state.loading) loadAllCollectionPages(root, state);
    });
  };
  const initialize = () => {
    document.querySelectorAll('[data-hsbd-stock-filter-root]').forEach((root) => {
      if (root.__hsbdStockOnlyState) {
        schedule(root, root.__hsbdStockOnlyState);
        return;
      }
      const state = { frame: 0, wrapper: null, wrapperObserver: null, rootObserver: null, controller: null, generation: 0, grid: null, queryKey: '', loadedKey: '', loading: false, errorMessage: '' };
      root.__hsbdStockOnlyState = state;
      state.rootObserver = new MutationObserver(() => schedule(root, state));
      state.rootObserver.observe(root, { childList: true, subtree: true });
      schedule(root, state);
    });
  };
  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!input || input.nodeType !== 1 || !input.matches('[data-hsbd-stock-only-toggle]')) return;
    const root = input.closest('[data-hsbd-stock-filter-root]');
    if (!root) return;
    const state = root.__hsbdStockOnlyState;
    writeState(input.checked);
    if (state) {
      state.errorMessage = '';
      if (!input.checked && state.loadedKey) {
        const url = new URL(window.location.href);
        url.searchParams.delete('section_id');
        url.searchParams.delete('sections');
        window.location.assign(url.toString());
        return;
      }
      schedule(root, state);
    }
  });
  window.addEventListener('popstate', initialize);
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', (event) => {
    const target = event.target;
    const root = target && target.matches && target.matches('[data-hsbd-stock-filter-root]')
      ? target
      : target && target.querySelector
        ? target.querySelector('[data-hsbd-stock-filter-root]')
        : null;
    const state = root && root.__hsbdStockOnlyState;
    if (!state) return;
    if (state.controller) state.controller.abort();
    if (state.rootObserver) state.rootObserver.disconnect();
    if (state.wrapperObserver) state.wrapperObserver.disconnect();
    if (state.frame) window.cancelAnimationFrame(state.frame);
    delete root.__hsbdStockOnlyState;
  });
  window.HSBDPhysicalStockOnly = { initialize };
  window.HSBDPhysicalStockOnly.initialize();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-stock-toggle-before-1020"]) return;
  try {
    
(() => {
  const storageKey = 'hsbdCollectionPhysicalStockOnly';
  let gridObserver = null;
  let parentObserver = null;
  let currentGrid = null;
  let fallbackEnabled = false;

  function getEnabled() {
    try {
      return window.sessionStorage.getItem(storageKey) === '1';
    } catch (error) {
      return fallbackEnabled;
    }
  }

  function setEnabled(value) {
    fallbackEnabled = value;
    try {
      window.sessionStorage.setItem(storageKey, value ? '1' : '0');
    } catch (error) {}
  }

  function applyStockFilter() {
    const grid = document.querySelector('#main-collection-product-grid');
    if (!grid) return;
    const enabled = getEnabled();
    const toggle = document.querySelector('[data-hsbd-stock-only-toggle]');
    if (toggle) toggle.checked = enabled;

    const cards = Array.from(grid.querySelectorAll('.product-index[data-product-id]'));
    let visibleCount = 0;
    cards.forEach((card) => {
      const isPhysicalStock = card.dataset.hsbdPhysicalStock === 'true';
      const hideCard = enabled && !isPhysicalStock;
      card.classList.toggle('hsbd-stock-only-hidden', hideCard);
      if (hideCard) card.setAttribute('aria-hidden', 'true');
      else {
        card.removeAttribute('aria-hidden');
        visibleCount += 1;
      }
    });

    let emptyMessage = grid.querySelector('[data-hsbd-stock-only-empty]');
    if (!emptyMessage) {
      emptyMessage = document.createElement('p');
      emptyMessage.className = 'span-12 auto hsbd-stock-only-empty';
      emptyMessage.dataset.hsbdStockOnlyEmpty = '';
      emptyMessage.setAttribute('role', 'status');
      emptyMessage.textContent = 'NO IN-STOCK ITEMS MATCH ON THIS PAGE. TRY ANOTHER PAGE OR TURN OFF THIS FILTER.';
      grid.appendChild(emptyMessage);
    }
    emptyMessage.hidden = !enabled || visibleCount > 0;

    const count = document.querySelector('[data-hsbd-stock-count]');
    if (count) count.textContent = enabled ? visibleCount + ' IN-STOCK ITEM' + (visibleCount === 1 ? '' : 'S') + ' ON THIS PAGE' : '';
  }

  function bindCollectionGrid() {
    const grid = document.querySelector('#main-collection-product-grid');
    if (!grid) return;
    if (grid !== currentGrid) {
      if (gridObserver) gridObserver.disconnect();
      currentGrid = grid;
      gridObserver = new MutationObserver(applyStockFilter);
      gridObserver.observe(grid, { childList: true, subtree: true });
    }
    applyStockFilter();
  }

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-hsbd-stock-only-toggle]')) return;
    setEnabled(event.target.checked);
    applyStockFilter();
  });

  function start() {
    bindCollectionGrid();
    const wrapper = document.querySelector('#CollectionProductGrid');
    if (wrapper && !parentObserver) {
      parentObserver = new MutationObserver(bindCollectionGrid);
      parentObserver.observe(wrapper, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();

  } catch(e) { console.error(e); }
})();
})();
